<app-wifi-student-details></app-wifi-student-details>
